define([
    'basecollection',
    'modules/common/models/role'
], (BaseCollection, Role) => BaseCollection.extend({
    model: Role,
    url: '/roles'
}));
